export default function getPageLevel(page) {
    return page.level || 0;
}
